// extracted by mini-css-extract-plugin
export var SourceCode = "styles-module--SourceCode--1kt3P";